import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import alarmIcon from "@phosphor-icons/core/regular/alarm.svg";

const CoeditingDocumentTool = lazy(
    () => import("../renderers/coediting-document-tool.tsx"),
);

export const smartGoalWriter: Tool = {
    urlSlug: "smart-goal-writer",
    configName: "teacher-tool-smart-goal-writer",
    title: () => t`Smart goal writer`,
    description: () =>
        t`Create specific, measurable, achievable, relevant, and time-bound goals`,
    categories: [ToolCategories.Support],
    icon: alarmIcon,
    color: color.fadedBlue24,
    layout: Layout.Coeditor,
    reportingLabelId: "smart-goal-writer",
    exportTargets: [
        "print",
        "download-pdf",
        "download-docx",
        "google-drive-docx",
        "microsoft-onedrive-docx",
    ],
    requestedInputs: [
        {
            description: () =>
                t`Optional. If not provided, we'll use a placeholder like [Student Name].`,
            inputKind: "TEXT_BOX",
            label: () => t`Student's first name`,
            variableName: "studentName",
            // TODO(reid): Figure out how name replacement should work
            // in Classroom/coediting v2.
            // shouldReplaceName: true,
        },
        {
            description: () => t`e.g., Improve a student's reading level`,
            inputKind: "TEXT_BOX",
            label: () => t`Overall goal(s)`,
            required: true,
            variableName: "title",
        },
        {
            description: () =>
                t`e.g., I want to help a student improve their reading level to a ... level, as measured by ... in ... amount of time`,
            inputKind: "TEXT_AREA",
            label: () => t`Desired outcome(s)`,
            required: true,
            variableName: "description",
        },
        {
            description: () => "",
            inputKind: "SINGLE_SELECT",
            label: () => t`Include detailed steps?`,
            required: true,
            selectOptions: [
                {
                    label: () => t`Yes`,
                    value: "items-steps",
                },
                {
                    label: () => t`No`,
                    value: "items",
                },
            ],
            variableName: "SGTemplateSelection",
        },
    ],
    component: ({providedInputs, configName, debugMode}) => {
        return (
            <CoeditingDocumentTool
                configName={configName}
                providedInputs={providedInputs}
                debugMode={debugMode}
            />
        );
    },
};
